<template lang="pug">
.icon-duo
  .icon-intile
    img.tile-icon-shadow(:src="iconSrc")
  .text {{ title }}
</template>

<script>

export default {
  name: 'IconDuo',
  computed: {
    iconSrc () {
      return require(`@/assets/imagesnew/${this.icon}`)
    }
  },
  props: {
    title: {
      type: String,
      default: 'Focus on leveraging data available online'
    },
    icon: {
      type: String,
      default: 'online-data.jpg'
    }
  }
}



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

$color-title: #364149;
$color-subtitle: #767F86;
.icon-duo {
  margin: 20px;
  .icon-intile {
    height: 80px;
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
  }
  .text {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 26px;
    text-align: center;
    color: $color-title;    
  }
}


</style>
